import styles from './MapLabels.module.css';

export const MapLabels = ({ measureLabel }) => (
    <div className={styles.labelsWrapper}>
        { measureLabel && <div className={styles.label}>{measureLabel}</div> }
    </div>
);

